import styled from '@emotion/styled'
import { Icon } from 'components/atoms'

export const IconClose = styled(Icon)`
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;
    z-index: 1100;
`
